import apiFetch from '../apiFetch'

export default function (numPedido, token) {   
  return apiFetch({endPoint: `Pedido/resetPedido`, method: 'POST', body: {numPedido}, token: token})
}